
  <span  *ngFor="let sites of sites$ | async" style="padding-top: 15px;">
    <img *ngIf="sites.dogF" src="assets/images/1.tv/dogF.svg" alt="" width="30" height="30">
  </span>

<span fxLayoutAlign="center center" class="item">
  <mat-icon [color]="iconColor" [ngClass]="'mat-icon-' + iconSize">call</mat-icon>
  <span  *ngFor="let sites of sites$ | async" class="px-1" >{{sites.phone}}</span>
</span>
<span *ngIf="dividers" class="v-divider" fxShow="false" fxShow.gt-xs></span>
<span fxLayoutAlign="center center" class="item" fxShow="false" fxShow.gt-xs>
  <mat-icon [color]="iconColor" [ngClass]="'mat-icon-' + iconSize">location_on</mat-icon>
  <span  *ngFor="let sites of sites$ | async" class="px-1">{{sites.address}}</span>
</span>
<span *ngIf="dividers" class="v-divider" fxShow="false" fxShow.gt-sm></span>
<span fxLayoutAlign="center center" class="item" fxShow="false" fxShow.gt-sm>
  <mat-icon [color]="iconColor" [ngClass]="'mat-icon-' + iconSize">mail</mat-icon>
  <span  *ngFor="let sites of sites$ | async" class="px-1">{{sites.email}}</span>
</span>
